import React from "react";
import { withRouter } from "react-router";

const ConfigButton = ({ title, pathname, history, search }) => {
  return (
    <div className="col">
      <button
        className={`btn ${
          pathname.includes(search) ? "btn-info" : "btn-outline-info"
        } btn-block`}
        onClick={() => {
          history.push(pathname);
        }}
      >
        {title}
      </button>
    </div>
  );
};

export default withRouter(ConfigButton);
